import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  const statusColor = comic.status === '连载中' ? 'bg-accent-500' : 'bg-secondary-500';

  return (
    <Link
      to={`/comic/${comic.slug}`}
      className="group block rounded-lg bg-background-50 hover:bg-background-100 transition-all duration-300 overflow-hidden"
    >
      <div className="relative aspect-[5/7] overflow-hidden rounded-lg">
        <img
          src={comic.cover}
          alt={`${comic.title} - 韩国漫画`}
          title={`${comic.title} - ${comic.author}作品`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className={`${statusColor} text-background-50 text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap`}>
            {comic.status}
          </span>
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <p className="text-white text-xs line-clamp-3">{comic.description}</p>
        </div>
      </div>
      <div className="p-2">
        <h3 className="text-sm font-semibold text-foreground-800 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
        <div className="flex items-center gap-2 mt-1.5">
          <span className="flex items-center text-xs text-primary-500">
            <i className="ri-star-fill text-xs mr-0.5"></i>
            {comic.rating}
          </span>
          <span className="text-xs text-foreground-400">
            {comic.views > 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views}阅读
          </span>
        </div>
      </div>
    </Link>
  );
}